var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTipsterDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_tipster_default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_tipster_default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#D5F9E6",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5326382,46.3118337 C65.400345,45.8466596 65.0034657,45.5143923 64.4742932,45.4479389 L55.3460684,43.985963 L51.3111284,35.1476546 C51.1126887,34.6824805 50.6496628,34.4166667 50.1204904,34.4166667 C50.1204904,34.4166667 50.1204904,34.4166667 50.1204904,34.4166667 C49.5913179,34.4166667 49.1944386,34.6824805 48.9298523,35.1476546 L44.7626192,43.9195096 L35.5682478,45.2485785 C35.1052219,45.315032 34.7083426,45.6472992 34.5099029,46.1124733 C34.3114632,46.5776475 34.4437563,47.1092751 34.7744891,47.4415423 L41.3891448,54.3527008 L39.8016275,64.0549041 C39.7354809,64.5200782 39.9339206,65.0517058 40.3307999,65.3175195 C40.7276792,65.5833333 41.2568517,65.6497868 41.7198776,65.383973 L49.9220507,60.8651386 L58.0580772,65.4504264 C58.2565169,65.5833333 58.4549566,65.5833333 58.7195428,65.5833333 C58.984129,65.5833333 59.2487152,65.5168799 59.4471549,65.383973 C59.8440342,65.1181592 60.0424739,64.5865316 59.9763274,64.1213575 L58.4549566,54.4191542 L65.2019054,47.5744492 C65.5326382,47.3086354 65.6649313,46.7770078 65.5326382,46.3118337 Z",
    id: "Shape",
    fill: "#6633ff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTipsterDefault);
export default __webpack_public_path__ + "static/media/ic_tipster_default.946367636421700b112b13817606e8f6.svg";
export { ForwardRef as ReactComponent };